import { render } from "./NovedadesAjustes.vue?vue&type=template&id=997da7be"
import script from "./NovedadesAjustes.vue?vue&type=script&lang=js"
export * from "./NovedadesAjustes.vue?vue&type=script&lang=js"

import "./NovedadesAjustes.vue?vue&type=style&index=0&id=997da7be&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__